<template>
  <div class="w-100 min-width-200 mx-0 d-flex flex-column align-center">
    <div class="filter-container mt-8">
  <v-select
    v-if="profileType === 'Admin'"
    v-model="selectedFilter"
    :items="filterOptions"
    outlined
    dense
    class="modern-filter"
    prepend-inner-icon="mdi-filter-variant"
    menu-props="{
      transition: 'slide-y-transition',
      maxHeight: 300,
      contentClass: 'filter-menu'
    }"
    hide-details
    color="primary"
  >
    <template v-slot:selection="{ item }">
      <div class="selection-content">
        <v-icon small class="mr-2">mdi-{{ item.icon }}</v-icon>
        <span class="selection-text">{{ item.text }}</span>
      </div>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title class="filter-item">
          <v-icon small class="mr-3">mdi-{{ item.icon }}</v-icon>
          {{ item.text }}
        </v-list-item-title>
      </v-list-item-content>
    </template>
  </v-select>
</div>
    <v-img
      :src="loader" 
      width="200px"
      contain
      v-show="!loadingMore && (loading || loadCompleted < events.length)"
    />
    <div
      v-show="loadingMore || (!loading && loadCompleted >= events.length)"
      class="w-100 max-width-650 event-feed-contents pb-3 px-5 align-center"
    >
      <create-event
        style="width: 100%"
        v-if="
          profileType == 'Volunteer' ||
            profileType == 'Agency' ||
            profileType == 'Company'
        "
      />
      <div v-else style="height: 20px"></div>
      <div
        v-for="(event, index) in events"
        :key="event._id"
        style="width: 100%"
      >
        <feed-event-card
          :_id="event._id"
          :eventIndex="events.length - index"
          :loadedData="loadedData"
          :loadMoreEvents="loadMoreEvents"
        />
        <ads-viewer v-if="index % 5 == 4" />
      </div>
      <v-progress-circular indeterminate color="amber" v-if="loadingMore" />
    </div>
    <div
      v-if="events.length == 0 && !loading"
      class="mt-6 d-flex flex-column justify-center align-center no-feed"
    >
      <div class="mb-3">
        <v-img
          :src="require('@/assets/svg/no-feed.svg')"
          style="width: 60px; height: 50px"
          contain
        />
      </div>
      No feeds available. Follow agencies or people to see their updates.
    </div>
    <v-snackbar v-model="snackbar">
      {{ errorMessage }}
    </v-snackbar>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AdsViewer from "../../components/ads/AdsViewer.vue";
import CreateEvent from "./CreateEvent.vue";
import FeedEventCard from "./FeedEventCard.vue";
export default {
  components: { CreateEvent, FeedEventCard, AdsViewer },
  data() {
    return {
      loading: false,
      errorMessage: null,
      snackbar: false,
      loadCompleted: -1,
      loadingMore: false,
      selectedFilter: "All",
      filterOptions: [
  { text: 'All Events', value: 'All', icon: 'view-grid' },
  { text: 'Individual', value: 'Individual', icon: 'calendar-clock' },
  { text: 'Competition', value: 'Competition', icon: 'history' } 
],
    };
  },
  watch: {
    selectedFilter(newFilter) {
      this.loading = true;
      this.fetchAllEvents({ option: newFilter })
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
          }
        });
    }
  },
  methods: {
    ...mapActions("event", {
      fetchAllEvents: "fetchAllEventsAdmin",
      loadMore: "loadMoreEvents"
    }),
    showErrorMessage(message) {
      this.errorMessage = message;
      this.snackbar = true;
    },
    loadedData() {
      this.loadCompleted++;
    },
    loadMoreEvents() {
      this.loadingMore = true;
      this.loadMore({ skip: this.events.length })
        .then(() => {
          setTimeout(() => {
            this.loadingMore = false;
          }, 2500);
        })
        .catch(error => {
          this.loadingMore = false;
          if (error.response == undefined) {
            console.log(error);
          } else {
            this.showErrorMessage(error.response.data.message);
          }
        });
    }
  },
  computed: {
    ...mapGetters({
      events: "event/getAllEvents",
      profileType: "auth/getType"
    }),
        loader() {
      // resolve the logo file based on .env string
      return require(`@/assets/${process.env.VUE_APP_LOADER}`);
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const option = urlParams.get("option") || "All";
    this.selectedFilter = option;
    this.loadCompleted = 0;
    this.loading = true;
    this.fetchAllEvents({ option })
      .then(() => {
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        if (error.response == undefined) {
          console.log(error);
        } else {
          this.showErrorMessage(error.response.data.message);
        }
      });
  }
};
</script>
<style scoped>
.event-feed-contents {
  display: flex;
  flex-direction: column;
}

.no-feed {
  font-size: 18px;
  color: #fff;
}

.dropdown-container {
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: flex-start;
}

.dropdown {
  width: 200px;
}

.filter-container {
  max-width: 300px;
  margin: 0 auto;
  background: #fff;
  border-radius:19px
}

@media (max-width: 600px) {
  .filter-container {
    max-width: 100%;
    padding: 0 16px;
      background: #fff;
  border-radius:19px
  }
}

.modern-filter {
  border-radius: 12px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.modern-filter .v-input__control {
  min-height: 48px;
}

.modern-filter .v-input__slot {
  background: white !important;
  border: 1px solid #e0e0e0 !important;
}

.modern-filter .v-input__slot:hover {
  border-color: blue !important;
  border-radius:20px
}

.modern-filter .v-input__slot:focus-within {
  border-color: blue !important;
  border-radius:20px;
  box-shadow: 0 0 0 2px rgba(var(--v-primary-base), 0.2);
}

.modern-filter :deep(.v-label) {
  color: #ffffff !important;
  font-weight: 500;
}

.modern-filter :deep(.v-label--active) {
  color: #ffffff !important;
}

.modern-filter .v-text-field__slot label {
  color: #ffffff !important;
  font-weight: 500;
}

.modern-filter .v-text-field__slot input {
  color: #333;
  font-weight: 500;
}

.modern-filter :deep(.v-select__selection) {
  color: #333 !important;
}

.selection-content {
  display: flex;
  align-items: center;
}

.selection-content .selection-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-menu {
  border-radius: 12px !important;
  margin-top: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.filter-item {
  font-weight: 500;
  padding: 8px 0;
  transition: all 0.2s ease;
}

.filter-item:hover {
  color: var(--v-primary-base);
  background: rgba(var(--v-primary-base), 0.05);
}

.v-list-item--active {
  color: var(--v-primary-base);
  background: rgba(var(--v-primary-base), 0.08);
}
</style>
